module.exports = {
  help: 'Помощь',
  logout: 'Выход',
  chats: 'Чаты',
  calls: 'Звонки',
  cancel: 'Отменить',
  go: 'Перейти',
  modal_warning_text: 'Внимание! При переключении между режимами вы перейдете на первую страницу раздела. Все несохраненные изменения на данной странице будут потеряны'
}
